export const urls = {
  // post
  ADD_COMPONENT: "gls:api:v2:component_add",
  ADD_LINKED_COMPONENT: "gls:api:v2:component_add_linked",
  REORDER_COMPONENT: "gls:api:v2:component_reorder",
  RESET_CACHES: "gls:api:v2:reset_caches",

  COMPONENT: "gls:api:v2:component",
  COMPONENT_PARAMS: "gls:api:v2:component_params",
  COMPONENT_LAYOUT_PARAMS: "gls:api:v2:component_layout_params",
  COMPONENT_TREE: "gls:api:v2:component_tree",
  COMPONENT_RENDER: "gls:api:v2:component_render",
  TYPE_COMPONENTS: "gls:api:v2:type_components_typed",
  LINKED_COMPONENTS: "gls:api:v2:linked_components_typed",
  TYPE_COMPONENT_CATEGORIES: "gls:api:v2:type_component_categories",
  PAGE_CONFIG: "gls:api:v2:page_config",
  PAGE_REVISION: "gls:api:v2:page_revision",
  PAGE_REVISIONS: "gls:api:v2:page_revisions",
  PAGE_REVISION_DUPLICATE: "gls:api:v2:page_revision_duplicate",
  PAGE_REVISION_PUBLISH: "gls:api:v2:page_revision_publish",
  DUPLICATE_PAGE: "gls:api:v2:page_duplicate",
  PAGE_CREATE: "gls:api:v2:page_create",
  PAGE_DELETE: "gls:api:v2:page_delete",
  PAGE_TEMPLATES: "gls:api:v2:page_template_list",
  DEVICE_LIST: "gls:api:v2:device_list",
  URL_NAME_LIST: "gls:api:v2:url_name_list",
  SITE_LIST: "gls:api:v2:site_list",
  TYPE_CONDITIONS: "gls:api:v2:type_conditions",
  TYPE_PARAMETER_LIST: "gls:api:v2:type_parameter_list",
  TYPE_URL_PARAMETER_LIST: "gls:api:v2:type_url_parameter_list",
  URLS_SEARCH: "gls:api:v2:urls_search",
  URLS_DETAIL: "gls:api:v2:url_detail",
  WHERE_IS: "gls:api:v2:where_is",

  AUTH_USER: "auth:api:v2:user_list",
  AUTH_GROUP: "auth:api:v2:group_list",

  AUTH_HAS_PERM: "auth:api:v2:has_perm",
  AUTH_MODULE_PERMS: "auth:api:v2:module_perms",

  CMS_ADMIN_PAGES: "cms:admin_pages",
  CMS_ADMIN_ARTICLES: "cms:admin_articles",
};
